export enum  INPUT_TYPE {
  RADIO = 'radio',
  TEXTAREA = 'textarea',
  CHECKBOX = 'checkbox',
  IMAGE = 'image',
}
